import { useRecordContext } from 'react-admin';
import { CopyToClipboardButton } from '@/components/buttons';

const CopyJSONToClipboard = () => {
  const record = useRecordContext();

  return (
    <CopyToClipboardButton
      label="COPY JSON"
      notifyProps={{
        onSuccess: {
          message: 'JSON copied to clipboard',
        },
      }}
      renderIcon={false}
      textToCopy={JSON.stringify(record?.webhook_data, null, 2)}
    />
  );
};

export default CopyJSONToClipboard;
